import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Sparkle = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      ref={forwardedRef}
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.9778 2.50076L4 2.44077L4.0222 2.50076C4.27541 3.18506 4.81494 3.72459 5.49924 3.9778L5.55923 4L5.49924 4.0222C4.81494 4.27541 4.27541 4.81494 4.0222 5.49924L4 5.55923L3.9778 5.49924C3.72459 4.81494 3.18506 4.27541 2.50076 4.0222L2.44077 4L2.50076 3.9778C3.18506 3.72459 3.72459 3.18506 3.9778 2.50076L3.50888 2.32724L3.9778 2.50076ZM4.23446 6.19286L4.23434 6.19252L4.23446 6.19286Z"
        stroke={color}
      />
      <path
        d="M10 3.94077L10.6974 5.82554C10.9506 6.50983 11.4902 7.04936 12.1745 7.30257L14.0592 8L12.1745 8.69743C11.4902 8.95064 10.9506 9.49017 10.6974 10.1745L10 12.0592L9.30257 10.1745C9.04936 9.49017 8.50983 8.95064 7.82554 8.69743L5.94077 8L7.82554 7.30257C8.50983 7.04936 9.04936 6.50983 9.30257 5.82554L10 3.94077Z"
        stroke={color}
      />
      <path
        d="M3.39481 12.5C3.87174 12.2593 4.25928 11.8717 4.5 11.3948C4.74072 11.8717 5.12826 12.2593 5.60519 12.5C5.12826 12.7407 4.74072 13.1283 4.5 13.6052C4.25928 13.1283 3.87174 12.7407 3.39481 12.5Z"
        stroke={color}
      />
    </svg>
  )
})

export default Sparkle
